<template>
  <Modal v-model="isOpen" :close="() => { setModal(false) }">
    <div class="lcu-modal">
      <div class="row row-center" v-if="loading">
        <spin-loader />
      </div>
      <div v-if="!loading">
        <div class="lcu-profilePic-container" v-if="!cropperOpen">
          <img
            :src="user.profilePic || '/assets/default-profile.svg'"
            class="lcu-profilePic-img"
            :alt="user.firstName + ' profile picture'" />
        </div>
        <button-upload
          :text="'Seleccionar Imagen'"
          :uploadText="'Subir y Guardar'"
          :crop="true"
          :bucket-path="'profile-pics/' + user.id + '/'"
          @on-cropper-toggle="onCropperToggle"
          @on-uploaded="onUploaded"
          :name="'profile-picture'" />
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import ButtonUpload from 'ç/buttons/Upload.vue';
import { NOTIFICATION_SUCCESS, NOTIFICATION_ERROR } from '@/globals/constants';

export default {
  name: 'profile-image-modal',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    SpinLoader,
    'button-upload': ButtonUpload,
  },
  props: ['is-open', 'image'],
  data() {
    return {
      loading: false,
      cropperOpen: false,
    };
  },
  methods: {
    setModal(val) {
      this.$emit('set-modal', val);
      this.cropperOpen = false;
    },
    onCropperToggle(open) {
      this.cropperOpen = !!open;
    },
    async onUploaded(file) {
      this.loading = true;
      try {
        await this.$students({
          method: 'updateUser',
          payload: {
            updates: {
              profilePic: file.Location,
            },
          },
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.user,
          key: 'profilePic',
          value: file.Location,
        });
        this.cropperOpen = false;
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Foto de perfil actualizada correctamente',
          type: 'success',
        });
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.$notify({
          title: NOTIFICATION_ERROR,
          text: message,
          type: 'error',
          duration: -1,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-profilePic-img {
  width: 100%;
}

.lcu-profilePic-container {
  border-bottom: 1px solid $page-border;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
</style>
